import { SET_OUTFIT_AVAILABLE } from "../actions/pdp-actions";

const defaultState = {
  productOutfitAvailability: {},
};

export default function outfitReducer(
  state = defaultState,
  { type, productKey, isAvailable }
) {
  switch (type) {
    case SET_OUTFIT_AVAILABLE:
      return {
        productOutfitAvailability: {
          [productKey]: isAvailable,
        },
      };
    default:
      return state;
  }
}
